export const MAX_REPLICATION = 10;

export const BUILD_TOOLS = {
  MAVEN: 'maven',
  PLAYWRIGHT: 'playwright',
  UFT: 'uft',
};
